(function () {
  "use strict";

  var SELECTOR = ".js-scheduled-section";
  var HIDDEN_CLASS = "is-scheduled-hidden";

  // KST fixed (UTC+9, no DST)
  var KST_OFFSET_MINUTES = 9 * 60;

  function parseBool(v) {
    return String(v).toLowerCase() === "true";
  }

  function parseDay(v) {
    var n = Number(String(v == null ? "" : v).trim());
    if (!Number.isInteger(n) || n < 0 || n > 6) return null;
    return n;
  }

  function parseTimeToMinutes(hhmm) {
    if (!hhmm) return null;
    var m = String(hhmm).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return null;

    var h = Number(m[1]);
    var min = Number(m[2]);

    if (!Number.isInteger(h) || !Number.isInteger(min)) return null;
    if (h < 0 || h > 23 || min < 0 || min > 59) return null;

    return h * 60 + min;
  }

  function parseDateKST(dateStr) {
    if (!dateStr) return null;
    var s = String(dateStr).trim();
    if (!s) return null;

    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;

    var y = Number(m[1]);
    var mo = Number(m[2]);
    var d = Number(m[3]);

    if (!Number.isInteger(y) || !Number.isInteger(mo) || !Number.isInteger(d)) return null;
    if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;

    return { y: y, mo: mo, d: d };
  }

  function parseTimeParts(hhmm) {
    if (!hhmm) return null;
    var m = String(hhmm).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return null;

    var h = Number(m[1]);
    var mi = Number(m[2]);

    if (!Number.isInteger(h) || !Number.isInteger(mi)) return null;
    if (h < 0 || h > 23 || mi < 0 || mi > 59) return null;

    return { h: h, mi: mi };
  }

  function parseDateAndTimeKST(dateStr, timeStr) {
    var d = parseDateKST(dateStr);
    var t = parseTimeParts(timeStr);
    if (!d || !t) return null;

    var utcMs =
      Date.UTC(d.y, d.mo - 1, d.d, t.h, t.mi, 0, 0) -
      (KST_OFFSET_MINUTES * 60 * 1000);

    var dt = new Date(utcMs);
    if (Number.isNaN(dt.getTime())) return null;
    return dt;
  }

  // old fallback: "YYYY-MM-DD HH:mm" / "YYYY-MM-DDTHH:mm"
  function parseDateTimeLocalKST(str) {
    if (!str) return null;
    var s = String(str).trim();
    if (!s) return null;

    var normalized = s.replace("T", " ");
    var m = normalized.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2})$/);
    if (!m) return null;

    var y = Number(m[1]);
    var mo = Number(m[2]);
    var d = Number(m[3]);
    var h = Number(m[4]);
    var mi = Number(m[5]);

    if (!Number.isInteger(y) || !Number.isInteger(mo) || !Number.isInteger(d)) return null;
    if (!Number.isInteger(h) || !Number.isInteger(mi)) return null;
    if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
    if (h < 0 || h > 23 || mi < 0 || mi > 59) return null;

    var utcMs =
      Date.UTC(y, mo - 1, d, h, mi, 0, 0) -
      (KST_OFFSET_MINUTES * 60 * 1000);

    var dt = new Date(utcMs);
    if (Number.isNaN(dt.getTime())) return null;
    return dt;
  }

  function getNow() {
    return new Date(); // absolute
  }

  function isWithinDateRange(now, start, end) {
    if (!start || !end) return false;
    if (end <= start) return false;
    return now >= start && now <= end;
  }

  function getKSTParts(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;

    var kstMs = date.getTime() + (KST_OFFSET_MINUTES * 60 * 1000);
    var kst = new Date(kstMs);

    return {
      day: kst.getUTCDay(),     // 0=Sun..6=Sat (KST)
      hours: kst.getUTCHours(),
      minutes: kst.getUTCMinutes()
    };
  }

  // 주간 "연속 구간" 반복 (KST 기준)
  // startDay/startMin ~ endDay/endMin
  // - startAbs < endAbs : 같은 주 내 구간
  // - startAbs > endAbs : 주 경계 넘김 (예: Fri -> Thu)
  function isNowInWeeklyWindowKST(now, startDay, startMin, endDay, endMin) {
    if (startDay == null || endDay == null) return false;
    if (startMin == null || endMin == null) return false;

    var kst = getKSTParts(now);
    if (!kst) return false;

    var nowDay = kst.day;
    var nowMin = kst.hours * 60 + kst.minutes;

    var WEEK_MIN = 7 * 24 * 60;

    var startAbs = startDay * 1440 + startMin;
    var endAbs = endDay * 1440 + endMin;
    var nowAbs = nowDay * 1440 + nowMin;

    if (startAbs === endAbs) return false;

    // same-week window
    if (startAbs < endAbs) {
      return nowAbs >= startAbs && nowAbs < endAbs;
    }

    // crosses week boundary
    return (nowAbs >= startAbs && nowAbs < WEEK_MIN) || (nowAbs >= 0 && nowAbs < endAbs);
  }

  function buildWeeklyWindow(enabled, startDay, startTime, endDay, endTime) {
    return {
      enabled: !!enabled,
      startDay: parseDay(startDay),
      start: parseTimeToMinutes(startTime),
      endDay: parseDay(endDay),
      end: parseTimeToMinutes(endTime)
    };
  }

  function getScheduleFromDataset(el) {
    var source = (el.dataset.scheduleSource || "").trim();

    if (source === "global_a") {
      return buildWeeklyWindow(
        parseBool(el.dataset.globalAEnabled),
        el.dataset.globalAStartDay,
        el.dataset.globalAStart,
        el.dataset.globalAEndDay,
        el.dataset.globalAEnd
      );
    }

    if (source === "global_b") {
      return buildWeeklyWindow(
        parseBool(el.dataset.globalBEnabled),
        el.dataset.globalBStartDay,
        el.dataset.globalBStart,
        el.dataset.globalBEndDay,
        el.dataset.globalBEnd
      );
    }

    if (source === "global_c") {
      return buildWeeklyWindow(
        parseBool(el.dataset.globalCEnabled),
        el.dataset.globalCStartDay,
        el.dataset.globalCStart,
        el.dataset.globalCEndDay,
        el.dataset.globalCEnd
      );
    }

    return { enabled: false, startDay: null, start: null, endDay: null, end: null };
  }

  function getOverrideFromDataset(el) {
    var enabled = parseBool(el.dataset.overrideEnabled);
    if (!enabled) return { enabled: false, mode: "", start: null, end: null };

    var start = parseDateAndTimeKST(el.dataset.overrideStartDate, el.dataset.overrideStartTime);
    var end = parseDateAndTimeKST(el.dataset.overrideEndDate, el.dataset.overrideEndTime);

    // old fallback
    if (!start && el.dataset.overrideStart) start = parseDateTimeLocalKST(el.dataset.overrideStart);
    if (!end && el.dataset.overrideEnd) end = parseDateTimeLocalKST(el.dataset.overrideEnd);

    return {
      enabled: true,
      mode: String(el.dataset.overrideMode || "").trim(), // force_show / force_hide
      start: start,
      end: end
    };
  }

  function evaluateVisibility(el, now) {
    var schedulingEnabled = parseBool(el.dataset.scheduleEnabled);
    var overrideCfg = getOverrideFromDataset(el);

    // 1) override 우선 (schedule_enabled ON/OFF 무관)
    if (overrideCfg.enabled) {
      if (overrideCfg.mode === "force_show") {
        // 해당 기간에만 표시, 기간 밖 숨김
        return isWithinDateRange(now, overrideCfg.start, overrideCfg.end);
      }

      if (overrideCfg.mode === "force_hide") {
        // 해당 기간에만 숨김
        if (isWithinDateRange(now, overrideCfg.start, overrideCfg.end)) return false;

        // 기간 밖:
        // schedule_enabled ON이면 global 스케줄로 복귀
        // OFF면 기본 표시
        if (!schedulingEnabled) return true;

        var schAfter = getScheduleFromDataset(el);
        if (!schAfter.enabled) return false;

        return isNowInWeeklyWindowKST(
          now,
          schAfter.startDay,
          schAfter.start,
          schAfter.endDay,
          schAfter.end
        );
      }

      // mode 이상값 안전 처리
      if (!schedulingEnabled) return true;
      var schFallback = getScheduleFromDataset(el);
      if (!schFallback.enabled) return false;
      return isNowInWeeklyWindowKST(
        now,
        schFallback.startDay,
        schFallback.start,
        schFallback.endDay,
        schFallback.end
      );
    }

    // 2) override OFF -> schedule_enabled 켜졌을 때만 global 적용
    if (schedulingEnabled) {
      var schedule = getScheduleFromDataset(el);
      if (!schedule.enabled) return false;

      return isNowInWeeklyWindowKST(
        now,
        schedule.startDay,
        schedule.start,
        schedule.endDay,
        schedule.end
      );
    }

    // 3) 둘 다 OFF -> 기본 표시
    return true;
  }

  function applyVisibility(el, visible) {
    el.classList.toggle(HIDDEN_CLASS, !visible);
  }

  function evaluateAll() {
    var now = getNow();
    var els = document.querySelectorAll(SELECTOR);
    els.forEach(function (el) {
      applyVisibility(el, evaluateVisibility(el, now));
    });
  }

  var intervalId = null;
  function startTimer() {
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(evaluateAll, 15 * 1000);
  }

  function init() {
    evaluateAll();
    startTimer();

    document.addEventListener("shopify:section:load", evaluateAll);
    document.addEventListener("shopify:section:reorder", evaluateAll);
    document.addEventListener("shopify:section:select", evaluateAll);
    document.addEventListener("shopify:block:select", evaluateAll);

    document.addEventListener("input", function () { evaluateAll(); }, true);
    document.addEventListener("change", function () { evaluateAll(); }, true);

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) evaluateAll();
    });
    window.addEventListener("focus", evaluateAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();